/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationAddBoxReqVo
 */
export interface AdminStockAdjustLocationAddBoxReqVo {
    /**
     * 会员ID
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxReqVo
     */
    userId: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxReqVo
     */
    warehouseId: number;
    /**
     * 纸箱计费物料ID
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxReqVo
     */
    materialId: number;
    /**
     * 长(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxReqVo
     */
    length: number;
    /**
     * 宽(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxReqVo
     */
    width: number;
    /**
     * 高(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxReqVo
     */
    height: number;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationAddBoxReqVo interface.
 */
export function instanceOfAdminStockAdjustLocationAddBoxReqVo(value: object): value is AdminStockAdjustLocationAddBoxReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('materialId' in value) || value['materialId'] === undefined) return false;
    if (!('length' in value) || value['length'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    return true;
}

export function AdminStockAdjustLocationAddBoxReqVoFromJSON(json: any): AdminStockAdjustLocationAddBoxReqVo {
    return AdminStockAdjustLocationAddBoxReqVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationAddBoxReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationAddBoxReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'warehouseId': json['warehouseId'],
        'materialId': json['materialId'],
        'length': json['length'],
        'width': json['width'],
        'height': json['height'],
    };
}

export function AdminStockAdjustLocationAddBoxReqVoToJSON(json: any): AdminStockAdjustLocationAddBoxReqVo {
    return AdminStockAdjustLocationAddBoxReqVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationAddBoxReqVoToJSONTyped(value?: AdminStockAdjustLocationAddBoxReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'warehouseId': value['warehouseId'],
        'materialId': value['materialId'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
    };
}

